import React from 'react';

/**
 * What the hub page offers its cards beyond navigation: one toast (`notify`, English copy as the key) and the one
 * buy-credits sheet (`openBuyCredits`, optionally primed with a credit amount). The page owns both, so two cards
 * never stack two toasts or two sheets. Outside the hub the defaults do nothing.
 */
export type WebsiteHubChrome = {
  notify: (message: string, placeholders?: Record<string, string | number>) => void;
  openBuyCredits: (suggested?: number) => void;
};

export const WebsiteHubChromeContext = React.createContext<WebsiteHubChrome>({
  notify: () => undefined,
  openBuyCredits: () => undefined,
});

export const useWebsiteHubChrome = (): WebsiteHubChrome => React.useContext(WebsiteHubChromeContext);
